import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgInstagram = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#FE0176"
        d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
      />
      <path
        fill="#fff"
        d="M9.898 12.096a2.198 2.198 0 1 1 4.397 0 2.198 2.198 0 0 1-4.397 0m-1.189 0a3.387 3.387 0 1 0 6.774 0 3.387 3.387 0 0 0-6.774 0m6.116-3.521a.791.791 0 1 0 1.583 0 .791.791 0 0 0-1.583 0m-5.394 8.89c-.643-.03-.992-.137-1.225-.227a2.05 2.05 0 0 1-.758-.494 2 2 0 0 1-.494-.758c-.09-.232-.197-.582-.227-1.225-.032-.695-.038-.904-.038-2.665s.007-1.97.038-2.666c.03-.643.137-.992.227-1.224a2.05 2.05 0 0 1 .494-.76c.23-.23.45-.373.758-.492.232-.091.582-.198 1.225-.227.695-.032.904-.039 2.665-.039 1.76 0 1.97.007 2.665.039.643.029.992.137 1.225.227.308.119.528.262.759.493s.373.45.493.759c.09.232.198.581.227 1.225.032.695.038.904.038 2.665s-.006 1.97-.038 2.666c-.03.643-.137.992-.227 1.224-.12.308-.262.528-.493.759s-.45.373-.759.493c-.232.09-.582.198-1.225.227-.695.032-.904.038-2.665.038s-1.97-.006-2.665-.038M9.377 5.54c-.703.032-1.182.143-1.601.306a3.2 3.2 0 0 0-1.169.761 3.2 3.2 0 0 0-.76 1.169c-.164.419-.275.898-.307 1.6-.033.704-.04.929-.04 2.72s.007 2.016.04 2.72c.032.701.143 1.18.306 1.6.169.434.394.802.761 1.169a3.2 3.2 0 0 0 1.169.76c.42.163.898.275 1.6.307.704.032.929.04 2.72.04s2.016-.008 2.72-.04c.701-.032 1.18-.144 1.6-.307a3.25 3.25 0 0 0 1.169-.76c.367-.367.591-.735.76-1.169.163-.42.275-.899.307-1.6.032-.705.04-.929.04-2.72s-.008-2.016-.04-2.72c-.032-.702-.144-1.181-.307-1.6a3.25 3.25 0 0 0-.76-1.169 3.2 3.2 0 0 0-1.168-.76c-.42-.164-.9-.276-1.601-.307-.704-.032-.928-.04-2.72-.04-1.79 0-2.016.007-2.72.04"
      />
    </svg>
  );
};
export default SvgInstagram;
